import * as React from "react";
const B4 = (props) => (
  <svg
    width={25}
    height={26}
    viewBox="0 0 25 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.5 25.5C11.6977 25.5 10.9419 25.0942 10.407 24.3868L8.66279 22.0677C8.62791 22.0213 8.48837 21.9634 8.43023 21.9518H7.84884C3 21.9518 0 20.6415 0 14.1248V8.32699C0 3.20176 2.7093 0.5 7.84884 0.5H17.1512C22.2907 0.5 25 3.20176 25 8.32699V14.1248C25 19.25 22.2907 21.9518 17.1512 21.9518H16.5698C16.4767 21.9518 16.3953 21.9981 16.3372 22.0677L14.593 24.3868C14.0581 25.0942 13.3023 25.5 12.5 25.5ZM7.84884 2.23933C3.68605 2.23933 1.74419 4.17579 1.74419 8.32699V14.1248C1.74419 19.366 3.54651 20.2124 7.84884 20.2124H8.43023C9.02326 20.2124 9.69767 20.5487 10.0581 21.0241L11.8023 23.3432C12.2093 23.8766 12.7907 23.8766 13.1977 23.3432L14.9419 21.0241C15.3256 20.5139 15.9302 20.2124 16.5698 20.2124H17.1512C21.314 20.2124 23.2558 18.276 23.2558 14.1248V8.32699C23.2558 4.17579 21.314 2.23933 17.1512 2.23933H7.84884Z"
      fill="#276AA6"
    />
    <path
      d="M12.4992 12.9651C11.8481 12.9651 11.3364 12.4433 11.3364 11.8056C11.3364 11.1678 11.8597 10.646 12.4992 10.646C13.1388 10.646 13.662 11.1678 13.662 11.8056C13.662 12.4433 13.1504 12.9651 12.4992 12.9651Z"
      fill="#276AA6"
    />
    <path
      d="M17.1506 12.9651C16.4994 12.9651 15.9878 12.4433 15.9878 11.8056C15.9878 11.1678 16.511 10.646 17.1506 10.646C17.7901 10.646 18.3134 11.1678 18.3134 11.8056C18.3134 12.4433 17.8017 12.9651 17.1506 12.9651Z"
      fill="#276AA6"
    />
    <path
      d="M7.84931 12.9651C7.19815 12.9651 6.68652 12.4433 6.68652 11.8056C6.68652 11.1678 7.20978 10.646 7.84931 10.646C8.48885 10.646 9.0121 11.1678 9.0121 11.8056C9.0121 12.4433 8.50048 12.9651 7.84931 12.9651Z"
      fill="#276AA6"
    />
  </svg>
);
export default B4;
